<template>
  <div class="third">
    <div class="third-formOne OfficialContact">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">官方联系方式配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button @click="Resect()" class="btn-two" type="default">重置</el-button>
          <el-button
            @click="preservation()"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>
      <el-form
        style="width:60%;float:left"
        @validate="validateValue"
        :show-message="false"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="86px"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <!-- <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">学生栏目名称</span>
              </div>
            </div>-->
            <div class="one-list">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="86px">
                <el-form-item
                  v-for="(item,index) in tableData"
                  :key="index"
                  :label="(index+1)+'、'"
                  prop="stuNumber"
                >
                  <el-select
                    clearable
                    v-model="item.type"
                    placeholder="请选择"
                    class="inputselect"
                    @change="()=>{
                      if(item.type==''){
                        item.placeholder='请输入'
                         item.max_length=30
                      }else if(item.type==1){
                         item.placeholder='请输入内容(20个字符以内)'
                         item.max_length=20
                      }else if(item.type==2){
                        item.placeholder='请输入链接'
                        item.max_length=200
                      }
                      item.value=''
                    }"
                  >
                    <!-- <el-option label="空" :value="0"></el-option> -->
                    <el-option label="文本" value="1"></el-option>
                    <el-option label="链接" value="2"></el-option>
                  </el-select>
                  <el-input
                    style="margin-right:8px; width: 163px;"
                    class="list-input"
                    :maxlength="6"
                    v-model.trim="item.key"
                    placeholder="标题(6个字以内)"
                  ></el-input>
                  <el-input
                    class="list-input"
                    :maxlength="30"
                    v-model.trim="item.key_en"
                    placeholder="英文版，不填默认使用中文版内容"
                  ></el-input>
                  <el-input
                    style="width:580px;display: block;margin-top:10px"
                    class="list-input"
                    :maxlength="item.max_length"
                    v-model.trim="item.value"
                    :placeholder="item.placeholder"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </el-form>
      <div class="phon-right" style="height: calc(100vh - 57px);">
        <img class="phon-right-img" src="@/assets/gffs.gif" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAppDetailList,
  updateAppDetails
} from "@/store/appconfig/OfficialContact"; //我的

export default {
  name: "formSeven",
  props: ["IDlist"],
  data() {
    return {
      countNum: 1, //用于显示第一个错误
      // dialogImageUrl: "",
      // dialogVisible: false,
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // },
      ], // 上传文件列表
      pointList: [],
      rules: {
        schoolId: [
          { required: true, message: "请输入学校代码", trigger: "blur" }
        ],
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" }
        ]
      },
      ruleForm: {
        schoolId: "", // 学校代码
        address: "", // 地址
        foundingYear: "", // 建校年月
        director: "", // 党建负责人(姓名+工号)
        directorId: "", //党建负责人工号
        schoolName: "", // 学校名称
        postcode: "", // 邮编
        schoolAnniversary: "", // 校庆日
        englishName: "", // 英文名称
        administrativeArea: [], // 行政区域
        presidentName: "", // 校长（姓名+工号）
        presidentId: "", //校长工号
        tel: "", // 学校联系电话
        email: "", // 学校电子邮箱
        homeUrl: "" // 主页地址
      },
      fileListlength: 0,
      //============
      tableData: "" //初始数据
    };
  },
  created() {
    this.getAppDetailListFN();
  },
  methods: {
    //重置
    Resect() {
      this.getAppDetailListFN();
    },
    //Preservation
    preservation() {
      let next = true;
      this.tableData.forEach(item => {
        if (item.type != ""||item.key!=""||item.value != "") {
          if (item.key == "" || item.value == ""||item.type == "") {
            next = false;
          }
        }
        // if (item.key != "") {
        //   if (item.type == "" || item.value == "") {
        //     this.$message.error("请填写完整信息");
        //     // next = false;
        //   }
        // }
        // if (item.value != "") {
        //   if (item.key == "" || item.type == "") {
        //     this.$message.error("请填写完整信息");
        //     // next = false;
        //   }
        // }
      });
      if (next) {
        this.updateAppDetailsFN();
      }else{
        this.$message.error("请填写完整信息");
      }
    },
    //保存
    updateAppDetailsFN() {
      try {
        const params = this.tableData;
        updateAppDetails(params).then(res => {
          const data = res.data;
          if (data.status === 1000) {
            this.$message.success("操作成功");
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //获取数据
    getAppDetailListFN() {
      try {
        getAppDetailList().then(res => {
          const data = res.data;
          console.log(data, 'data')
          if (data.status === 1000) {
            this.tableData = data.result;
            this.tableData.forEach(item => {
              item.placeholder = "请输入";

              if(item.type==''){
                item.placeholder='请输入'
                  item.max_length=30
              }else if(item.type==1){
                  item.placeholder='请输入内容(20个字符以内)'
                  item.max_length=20
              }else if(item.type==2){
                item.placeholder='请输入链接'
                item.max_length=200
              }
            });
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },

    //========================================================
    //上传图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //移除
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.ruleForm.icon = "";
    },
    // 超出
    handleExceed(files, fileList) {
      console.log(files, fileList);
    },
    // 成功
    handleSuccess() {
      console.log(this.fileList);
      console.log(111);
      this.fileListlength = 1;
    },
    // 上传之前
    beforeUpload(file) {
      console.log(file);
    },
    // 上传失败
    hadleError(err) {
      this.$message.error(err);
    },
    async facUpload(params) {
      console.log(params);
      //   try {
      //     let reqData = new FormData();
      //     reqData.append("tenantId", this.$store.state.user.tenantId);
      //     reqData.append("file", params.file);
      //     // const reqData = {
      //     //   tenantId: this.$store.state.user.tenantId, //大学id  （当前登录用户id）
      //     //   file:params.file
      //     // };
      //     await upicon(reqData).then(res => {
      //       const data = res.data;
      //       console.log("这是图片上传接口", data);
      //       if (data.status === 1000) {
      //         this.$message.success("上传图片成功");
      //         // this.fileList.url = data.result;
      //         // this.fileList.push({
      //         //   // name: params.file.name,
      //         //   url: data.result
      //         // });
      //         this.ruleForm.icon = data.result;
      //         console.log("上传的图片文件", this.ruleForm.icon);
      //       } else {
      //         this.$message.error(data.msg);
      //       }
      //     });
      //   } catch (err) {
      //     console.log(err);
      //   }
    },
    //获取学校详情
    selectinfo() {
      //   try {
      //     const params = {
      //       eduSchoolInfo: {
      //         tenantId: this.$store.state.user.tenantId //大学id  （当前登录用户id）
      //       }
      //     };
      //     selectxuexiao(params).then(res => {
      //       const data = res.data;
      //       console.log("这是学校管理的详情接口", data);
      //       if (data.status === 1000) {
      //         this.ruleForm = data.result;
      //         let arr = [];
      //         arr = this.ruleForm.administrativeArea.split(",");
      //         this.ruleForm.administrativeArea = arr;
      //         console.log("这是学校管理的详情数据", this.ruleForm);
      //       }
      //     });
      //   } catch (err) {
      //     console.log(err);
      //   }
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            return this.save();
          } else {
            return false;
          }
        });
      });
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //新增/修改学校信息
    save() {
      //   try {
      //     let administrativeArea = "";
      //     if (this.ruleForm.administrativeArea !== []) {
      //       administrativeArea = this.ruleForm.administrativeArea.join(",");
      //     }
      //     const params = {
      //       eduSchoolInfo: {
      //         tenantId: this.$store.state.user.tenantId, //大学id  (当前登录用户处取得  值为当前登录用户ID)
      //         schoolId: this.ruleForm.schoolId, //学校代码  ruleForm.schoolNum
      //         schoolName: this.ruleForm.schoolName, //学校名称  ruleForm.schoolNam
      //         englishName: this.ruleForm.englishName, //英文名称  ruleForm.Ename
      //         address: this.ruleForm.address, //地址         ruleForm.Dz
      //         postcode: this.ruleForm.postcode, //邮编       ruleForm.YB
      //         administrativeArea: administrativeArea, //行政区域   ruleForm.XingZ
      //         foundingYear: this.ruleForm.foundingYear, //建校年月      ruleForm.JXDate
      //         schoolAnniversary: this.ruleForm.schoolAnniversary, //校庆日    ruleForm.XQdate
      //         presidentName: this.ruleForm.presidentName, //校长姓名      ruleForm.XiaoZ
      //         presidentId: this.ruleForm.presidentId, //校长工号      ruleForm.XiaoZ
      //         director: this.ruleForm.director, //党建负责人     ruleForm.DJpeople
      //         directorId: this.ruleForm.directorId, //党建负责人工号    ruleForm.DJpeople
      //         tel: this.ruleForm.tel, //学校联系电话      ruleForm.schoolPho
      //         email: this.ruleForm.email, //学校电子邮箱     ruleForm.schoolEmai
      //         homeUrl: this.ruleForm.homeUrl //主页地址        ruleForm.ZYplace
      //       }
      //     };
      //     addxuexiao(params).then(res => {
      //       const data = res.data;
      //       console.log("这是学校管理新增/编辑接口", data);
      //       if (data.status === 1000) {
      //         this.selectinfo();
      //         this.$message.success("保存成功");
      //       }else{
      //          this.$message.error(data.msg);
      //       }
      //     });
      //   } catch (err) {
      //     this.$message.error(err);
      //     console.log(err);
      //   }
    },
    //表单验证
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //表单重置
    async resetForm(formName) {
      // this.ruleForm.administrativeArea = [];
      // this.ruleForm.createTime = "";
      // this.ruleForm.director = "";
      // this.ruleForm.directorId = "";
      // this.ruleForm.foundingYear = "";
      // this.ruleForm.presidentId = "";
      // this.ruleForm.presidentName = "";
      // this.ruleForm.schoolAnniversary = "";
      // this.ruleForm.updateTime = "";
      // console.log("重置", this.ruleForm);
      await this.selectinfo();
      this.$refs[formName].resetFields();
    },
    // 关闭预览弹窗
    // closePreview() {
    //   this.dialogVisible = false;
    // },
    //行政区域选中节点
    handleChange(value) {
      console.log(value);
    }
  }
};
</script>

<style lang="scss">
.OfficialContact {
  .inputselect {
    width: 85px;
    margin-right: 8px;
  }
}
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height:calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
</style>
